<template>
  <div class="app-container">
    <h1 class="app-tit">{{ t('policy_payment') }}</h1>
    <div class="head-txt-wrap">
      <strong>시행일 : 2025년 12월 01일</strong>
      <p>
        본 정책은 SconAI(이하 "회사")가 제공하는 SconChat 서비스(이하 "서비스")의 유료 구독 서 비스 이용과 관련하여,
        결제 및 환불에 관한 사항을 규정함을 목적으로 합니다.
      </p>
    </div>
    <div class="marker-txt-wrap">
      <div class="txt-group">
        <h2>제 1조 (서비스 이용 요금)</h2>
        <ul class="marker-dot">
          <li>회사가 제공하는 서비스는 유료 구독 방식으로 제공됩니다</li>
          <li>
            서비스 이용 요금은 회사가 정한 요금제에 따라 부과되며, 각 요금제의 세부 내용은 웹사이트에 서 확인할 수
            있습니다.
          </li>
          <li>이용자는 회사가 정한 결제 수단을 통해 서비스 이용 요금을 납부해야 합니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제2조 (결제 방식 및 자동 결제)</h2>
        <ul class="marker-dot">
          <li>
            이용자는 추가 결제와 관련된 세부 설정(자동결제 사용 여부, 충전 시점, 1회 충전 금액, 추가 결 제 한도 금액)을
            미리 지정할 수 있습니다.
          </li>
          <li>
            회사는 이용자가 선택한 요금제에 포함된 서비스 사용량(예: 통역 시간, 크레딧 등)을 초과하여 서비스를 이용할
            경우, 사전에 이용자가 동의하고 지정한 설정에 따라 추가 요금을 자동 결제할 수 있습니다.
          </li>
          <li>
            추가 결제를 비활성화했거나, 이용자 또는 회사가 설정한 사용량 한도를 초과한 경우에는 서비 스 이용이 제한될 수
            있습니다.
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 3조 (추가 결제 정책)</h2>
        <ul class="marker-dot">
          <li>
            회사는 이용자가 선택한 요금제에 포함된 서비스 사용량(예: 통역 시간, 크레딧 등)을 초과하여 서비스를 이용할
            경우, 해당 초과분에 대해 추가 요금을 부과할 수 있습니다.
          </li>
          <li>
            추가 요금은 이용자가 선택한 요금제 또는 추가 사용량에 대한 별도 상품에 따라 자동으로 결제 됩니다. 추가 결제
            방식 및 요율은 웹사이트 또는 앱 내에서 안내됩니다.
          </li>
          <li>이용자는 추가 결제에 대한 세부 내용을 사전에 확인하고 동의해야 합니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 4조 (보유 및 이용 기간)</h2>
        <ul class="marker-dot">
          <li class="non-marker">
            1. 일반 원칙 : 회사는 「콘텐츠산업진흥법」, 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관 련 법령을
            준수하여 이용자의 환불 요청을 처리합니다.
          </li>
          <li class="non-marker">
            <h3>2. 구독 해지 및 환불</h3>
            <div class="inr mk-hp-wrap">
              <h4>가) 구독 해지</h4>
              <p class="marker-hyphen">
                이용자가 서비스 구독을 해지하는 경우, 다음 결제일부터 요금이 청구되지 않습니다.
              </p>
              <p class="marker-hyphen">현재 결제된 기간에 대한 서비스는 계속 이용할 수 있습니다.</p>
            </div>
            <div class="inr mk-hp-wrap">
              <h4>나) 환불 정책</h4>
              <strong>전액 환불</strong>
              <p class="marker-hyphen">
                결제일로부터 7일 이내에 서비스를 개시하지 않은 상태에서 해지를 요청한 경우 전액 환불 합니다.
              </p>
              <p class="marker-hyphen">서비스의 중대한 결함으로 인해 정상적인 이용이 불가능한 경우</p>
              <p class="marker-hyphen">기타 법령에 따라 환불이 의무화된 경우</p>
              <strong>부분 환불</strong>
              <p class="marker-hyphen">
                서비스를 개시하였거나, 결제일로부터 7일이 지났다면 아래 기준에 따라 환불됩니다.
              </p>
              <p class="marker-hyphen">
                사용 후 남은 크레딧과 사용 기간을 일할 계산한 크레딧 중 더 작은 금액을 기준으로 환불합 니다.
              </p>
              <p class="marker-hyphen">할인된 금액은 환불 대상에서 제외됩니다.</p>
              <p class="marker-hyphen">이용자의 단순 변심으로 인한 환불 시 결제 수수료를 제외한 금액이 환불됩니다.</p>
            </div>
          </li>
          <li class="non-marker">
            <h3>3. 환불 절차 :</h3>
            <ul class="marker-dot">
              <li>가) 환불을 요청하려는 이용자는 고객센터를 통해 환불 사유와 결제 정보를 회사에 제출해 야 합니다.</li>
              <li>
                나) 회사는 환불 요청을 접수한 날로부터 3영업일 이내에 환불 가능 여부를 심사하고, 환불 이 결정된 경우
                3영업일 이내에 처리합니다.
              </li>
              <li>다) 결제 수단에 따라 수수료가 발생할 수 있으며, 이는 이용자가 부담합니다.</li>
              <li>라) 환불 금액은 남은 크레딧을 환산한 금액에서 할인 금액 등을 제외하여 산정합니다.</li>
            </ul>
          </li>
          <li class="non-marker">
            <h3>추가 결제에 대한 환불:</h3>
            <div class="inr mk-hp-wrap">
              <p class="marker-hyphen">
                추가 결제 금액에 대한 환불은 해당 추가 결제가 발생한 원인 및 이용 내역을 기준으로 본 조의 환불 기준에
                따라 처리합니다.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 5조 (과오납금의 환불)</h2>
        <ul class="marker-dot">
          <li>
            회사의 고의 또는 과실로 인해 이용자에게 과오납금이 발생한 경우, 회사는 과오납된 금액을 전 액 환불합니다.
          </li>
          <li>
            이용자의 귀책사유로 과오납금이 발생한 경우, 회사는 환불 과정에서 발생하는 비용(수수료 등) 을 공제한 후
            환불할 수 있습니다.
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 6조 (정책의 변경)</h2>
        <ul class="marker-dot">
          <li>
            회사는 본 결제 및 환불 정책을 변경할 수 있으며, 변경 시에는 시행일 7일 전부터 서비스 웹사 이트에 공지합니다.
          </li>
          <li>다만, 이용자에게 불리한 중대한 변경이 발생할 경우 최소 30일 전에 공지합니다.</li>
          <li>본 결제 및 환불 정책의 시행일은 2025년 12월 01일입니다.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped lang="scss">
.app-container {
  padding: 0 0 4rem;
}

.head-txt-wrap {
  padding: 1rem 0;
  strong {
    font-size: $font-size-psmall;
    font-weight: 500;
    display: block;
    margin-bottom: $size-xs;
  }
  p {
    font-size: $font-size-psmall;
    color: $color-gray-500;
  }
}
.marker-txt-wrap {
  .marker-dot {
    .non-marker {
      padding-left: 0;
      margin-bottom: $size-s;
      &::before {
        display: none;
      }
    }
    h3 {
      display: block;
      font-size: $font-size-psmall;
      font-weight: 600;
      padding-bottom: $size-s;
    }
    .inr {
      padding-bottom: $size-s;
      &.mk-hp-wrap {
        padding-left: $size-m;
        h4 {
          font-size: $font-size-psmall;
          font-weight: 600;

          padding-bottom: $size-xs;
        }
      }
      p {
        font-size: $font-size-psmall;
      }
    }
  }
  .last-txt {
    padding: 1rem 0;
    font-size: $font-size-psmall;
  }
}
</style>
